import printJS from "print-js";

export const units = ['', 'קרטון', 'ארגז', 'ק\'\'ג', 'יח\'', 'משטח', 'כללי'];

export interface ProductOrder {
    name: string;
    barcode: string;
    id: number;
    flag: string;
    amount: number;
    price: number;
    with_karton: boolean;
    name_karton: string;
    rate_karton: string;
    rate_karton_number: number;
    amount_karton: number;
    position: number;
}

export class ClientLink {

    client_id: number;

    client_name: string;

    client_link: string;

    phone: string;

    order: any;

}

export const sortNumber = (direction: any, a: any, b: any): number => {
    let first: number;
    if (a == null) {
        first = 0;
    } else {
        first = Number(a);
    }
    let second: number;
    if (b == null) {
        second = 0;
    } else {
        second = Number(b);
    }
    if (first < second) {
        return 1 * direction;
    }
    if (first > second) {
        return -1 * direction;
    }
    return 0;
};
export const decToString = (num: number): string => num.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
});
export const StringToIsrael = (s: string, withTime: boolean = true): string => {
    const str = s.split(' ');

    const d = str[0].split('-');
    const day: any = Number(d[2]);
    const month: any = Number(d[1]);
    const year: any = Number(d[0]);

    let h: number = 0;
    let m: number = 0;
    let sec: number = 0;
    if (str.length > 1) {
        const d2 = str[1].split(':');
        h = (d2[0]);
        m = (d2[1]);
        sec = (d2[2]);

    }
    if (withTime)

        return `${h}:${m}:${sec} ${day}-${month}-${year}`;
    else
        return `${day}-${month}-${year}`;
};
export const dateObjectToStringIsrael = (d: Date): string => {
    let day: any = d.getDate();
    let month: any = d.getMonth() + 1;
    const year: any = d.getFullYear();
    if (day < 10)
        day = `0${day}`;
    if (month < 10)
        month = `0${month}`;
    return `${day}-${month}-${year}`;
};
export const startOfWeek = (d: Date): Date => {
// Getting the day of the week as a number (0 for Sunday through 6 for Saturday)
    const currentDayOfWeek = d.getDay();

// Getting the start of the week (Sunday)
    const startOfWeek = new Date(d);
    startOfWeek.setDate(d.getDate() - currentDayOfWeek);
    return startOfWeek;
// Getting the end of the week (Saturday)

};

export const endOfWeek = (d: Date): Date => {
// Getting the day of the week as a number (0 for Sunday through 6 for Saturday)
    const currentDayOfWeek = d.getDay();

    const endOfWeek = new Date(d);
    endOfWeek.setDate(d.getDate() + (6 - currentDayOfWeek));
    return endOfWeek;
};
export const startOfMonth = (d: Date): Date => {
    let startOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);
    return startOfMonth;
};
export const endOfMonth = (d: Date): Date => {
    let endOfMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return endOfMonth;
};
export const subtractMonths = (d: Date, months: number): Date => {
    let result = new Date(d);
    result.setMonth(d.getMonth() - months);
    return result;
};
export const monthDay = (d: Date): string => {
    let day: any = d?.getDate();
    let month: any = d?.getMonth() + 1;
    return `${day}-${month}`;
};

export function stringToTime(dateString: string): Date {
    const [hours, minutes = '00'] = dateString.split(':').map(Number); // Default minutes to '00' if not provided
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set seconds and milliseconds to 0
    return date;
}

export const dateObjectToString = (d: Date): string => {
    let day: any = d?.getDate();
    let month: any = d?.getMonth() + 1;
    const year: any = d?.getFullYear();
    if (day < 10)
        day = `0${day}`;
    if (month < 10)
        month = `0${month}`;
    return `${year}-${month}-${day}`;
};
export const dateTimeObjectToString = (d: Date): string => {
    let day: any = d.getDate();
    let month: any = d.getMonth() + 1;
    const year: any = d.getFullYear();
    if (day < 10)
        day = `0${day}`;
    if (month < 10)
        month = `0${month}`;
    const hours = d.getHours()
    const minutes = d.getMinutes()
    const seconde = d.getSeconds()
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconde}`;
};
export const StringToDateObject = (s: string): Date => {
    const d = s.split('-');
    const day: any = Number(d[2]);
    const month: any = Number(d[1]) - 1;
    const year: any = Number(d[0]);

    return new Date(year, month, day);
};
export const sortDateIsraelStr = (s: string, sep = '-'): number => {
    if (!s)
        return 0
    const str = s.split(' ');

    const d = str[0].split(sep);

    const day: any = (d[0]) ?? '';
    const month: any = (d[1]) ?? '';
    const year: any = (d[2]) ?? '';

    let h: number = 0;
    let m: number = 0;
    let sec: number = 0;
    const str2 = str;

    return (new Date(`${year}-${month}-${day} ${h}:${m}:${sec}`)).getTime()
};
export const StringToDateObjectAddTime = (s: string, p: string): Date => {
    const str = s.split(' ');

    const d = str[0].split('-');
    const day: any = Number(d[2]);
    const month: any = Number(d[1]) - 1;
    const year: any = Number(d[0]);

    let h: number = 0;
    let m: number = 0;
    let sec: number = 0;
    const str2 = p.split(' ');
    if (str2.length > 1) {
        const d2 = str2[1].split(':');
        h = Number(d2[0]);
        m = Number(d2[1]);
        sec = Number(d2[2]);

    }
    return new Date(year, month, day, h, m, sec);
};
export const StringToDateTimeObject = (s: string): Date => {
    const str = s.split(' ');

    const d = str[0].split('-');
    const day: any = Number(d[2]);
    const month: any = Number(d[1]) - 1;
    const year: any = Number(d[0]);

    let h: number = 0;
    let m: number = 0;
    let sec: number = 0;

    if (str.length > 1) {
        const d2 = str[1].split(':');
        h = Number(d2[0]);
        m = Number(d2[1]);
        sec = Number(d2[2]);

    }
    return new Date(year, month, day, h, m, sec);
};


export const cloneObject = (object): any => ({...object});
export const cloneArray = (arr: any[]): any[] => {
    const myClonedArray: any[] = [];
    arr.forEach(val => myClonedArray.push(val));
    return myClonedArray;
};
export function printPdfMobile  (byteArray)  {
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(blob);

    // Open the PDF in a new tab to allow printing
    const newTab = window.open(fileURL, '_blank');
    if (newTab) {
        newTab.onload = () => newTab.print();
    } else {
        alert('Please allow pop-ups to print the document.');
    }
};

export function printPdf(byteArr) {
    const pdfFile = new Blob([byteArr], {
        type: "application/pdf"
    });
    const pdfUrl = URL.createObjectURL(pdfFile);

    printJS(pdfUrl);
}
export async function sharePdfToWhatsApp(byteArray, name, desc, type = 'application/pdf') {
    console.log("Starting share process...");

    try {
        // Convert ByteArray to Blob & File
        const blob = new Blob([byteArray], { type });
        const file = new File([blob], name, { type });

        console.log("Checking if navigator.share is available...");
        console.log("Can Share:", navigator.canShare ? navigator.canShare({ files: [file] }) : false);

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
            console.log("navigator.share() is supported! Attempting to share...");
            await navigator.share({
                title: name,
                text: desc,
                files: [file],
            });
            console.log("Sharing completed successfully!");
        } else {
            console.warn("Sharing not supported on this browser.");
            alert("Sharing is not supported on this device/browser.");
        }
    } catch (error) {
        console.error("Error during sharing:", error);
    }
}

export function saveByteArray(byteArr, name, type = 'application/pdf') {
    try {
        const reportName = `${type == 'application/pdf' ? name.replaceAll(".", "_") : name}`;
        const blob = new Blob([byteArr], {type});
        const link = document.createElement('a');
        const objectURL = window.URL.createObjectURL(blob);
        link.href = objectURL;
        const fileName = reportName;
        link.download = fileName;
        // link.addEventListener('click', (e) => {
        //     e.preventDefault();
        // });
        requestAnimationFrame(() => {
            link.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(objectURL);  // Revoke the object URL after a short delay
            }, 100);  // 100ms delay
        });
    } catch (error) {
        console.error('An error occurred while downloading the file:', error);
    }
}

export function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}


export function base64ToArrayBuffer(base64: string) {
    if (base64.length == 0)
        return null;
    const splitted = base64.split('base64');
    if (splitted.length <= 1) {
        return null;
    }
    const base = splitted[1].substring(1);
    const binary_string = window.atob(base);
    const len = binary_string.length;
    const bytes = new Int8Array(len);
    for (let i = 0; i < len; i += 1) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}


export function byteArrayToImg(byteArr: any) {
    const base64 = arrayBufferToBase64(byteArr);
    return `data:image/jpeg;base64,${base64}`;
}

export const badPhoto = 'data:image/jpeg;base64,eyJzdGF0dXMiOiJFUlJPUiIsInN0YXR1c19tc2ciOiJJbnRlcm5hbCBFcnJvciJ9Cg==';
export const emptyPhoto = 'data:image/png;base64,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';

export const note_icon = 'data:image/png;base64,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';

export function roundDecimals(x: number, f: number = 2): number {
    const pow = Math.pow(100, f)
    return Number((Math.round(x * pow) / pow).toFixed(f))

};
